import React from "react";
import { Hero } from "./components/sections/Hero";
import { StatsStrip } from "./components/sections/StatsStrip";
import { Problems } from "./components/sections/Problems";
import { Solution } from "./components/sections/Solution";
import { Contents } from "./components/sections/Contents";
import { SampleCarousel } from "./components/sections/SampleCarousel";
import { Bonuses } from "./components/sections/Bonuses";
import { OfferDetails } from "./components/sections/OfferDetails";
import { Guarantee } from "./components/sections/Guarantee";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ivory font-sans text-charcoal" data-id="element-0" data-mp="2wip6p3k1bk5g">
      <main data-id="element-1" data-mp="28sl3uyeo7ofi">
        <Hero data-id="element-2" data-mp="28sbad0uf2z52" />
        <StatsStrip data-id="element-3" data-mp="23vchelmhoy8g" />
        <Problems data-id="element-4" data-mp="23vupcfiil0w7" />
        <Solution data-id="element-5" data-mp="23u9q4cl98ts0" />
        <Contents data-id="element-6" data-mp="23ut9lxqjzq85" />
        <SampleCarousel data-id="element-7" data-mp="23ti8y6semyl9" />
        <Bonuses data-id="element-8" data-mp="3ik7e6ay3c1o0" />
        <OfferDetails data-id="element-9" data-mp="3ikqytzf4l45q" />
        <Guarantee data-id="element-10" data-mp="3ijfvu1ti80fo" />
        <Faq data-id="element-11" data-mp="3ihv048vgebg8" />
        <FinalCta data-id="element-12" data-mp="3mlja0y7k5j4n" />
      </main>
      <Footer data-id="element-13" data-mp="3mkrefndynled" />
    </div>;
}